import { Injectable } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { CommonRecipeModel } from 'src/app/model/common/recipe';
import { generalConsultActions } from 'src/app/store/general/general.action';
import { environment } from 'src/environments/environment';
import { CommonRecipeViewModel } from '../../../model/common/recipe-view';

@Injectable({
  providedIn: 'root',
})
export class GeneralRecipeService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  loadRecipeInfo = (turn: number): Observable<CommonRecipeModel[]> =>
    this.rest.get<CommonRecipeModel[]>({
      url: `${environment.endpoints.common}/recipe/{turn}`,
      urlParams: { turn },
    });

  isSaving = (): Observable<boolean> =>
    this.store.select('general', 'consult', 'saving');

  save = (
    turn: number,
    body: CommonRecipeModel[],
    remove: number[]
  ): Observable<CommonRecipeModel[]> =>
    this.rest
      .post<CommonRecipeModel[]>({
        url: `${environment.endpoints.common}/recipe`,
        body,
        params: { turn, remove },
      })
      .pipe(
        tap({
          next: () => this.addToSaved(),
          error: () => this.addToSaved(),
        })
      );

  generateRecipe = (turnId: number): Observable<SafeResourceUrl> =>
    this.rest
      .get({
        url: `${environment.endpoints.report}/medical-recipe`,
        params: { turnId },
        header: {
          responseType: 'BLOB' as 'json',
        },
      })
      .pipe(map(this.rest.mapResponseAsPdf));

  addToSaved = (value: number = 1) =>
    this.store.dispatch(generalConsultActions.addToSavedAction({ value }));

  getByQuery = (query: string): Observable<CommonRecipeViewModel[]> =>
    this.rest
      .get<CommonRecipeViewModel[]>({
        url: `${environment.endpoints.common}/medicine/autocomplete`,
        params: { query },
      })
      .pipe(
        map((res) => {
          const parents = res.map((item) => ({
            code: item.atcParentCode,
            name: item.atcParentName,
          }));
          const grouped: CommonRecipeViewModel[] = [];

          for (let idx = 0; idx < parents.length; idx++) {
            const parent = parents[idx];
            const found = grouped.find((item) => item.atcCode === parent.code);
            if (!found) {
              const group: CommonRecipeViewModel = {
                id: (idx + 1) * -1,
                atcCode: parent.code,
                label: parent.name,
                children: res
                  .filter((item) => item.atcParentCode === parent.code)
                  .map((item) => ({
                    ...item,
                    label:
                      (item.turn ?? 0) > -1
                        ? `(Compuesto: ${item.atcName}) - Nombre comercial: ${item.name} - Cantidad: ${item.quantity} - Indicaciones:${item.instructions}`
                        : `(Compuesto: ${item.atcName}) - ${item.name}`,
                  })),
              };
              grouped.push(group);
            }
          }
          return grouped;
        })
      );
}
